import { FaPencilAlt } from "react-icons/fa";
import { Accordion, ActionIcon, Flex, Text, Tooltip } from "@mantine/core";
import { IconChevronDown, IconMenu2 } from "@tabler/icons-react";

/* eslint-disable @typescript-eslint/no-explicit-any */
const DetailTemplateSection = ({
  title,
  children,
  provided,
  onEditSection,
}: any) => {
  return (
    <Accordion
      variant="separated"
      defaultValue={title}
      radius={10}
      mb={15}
      transitionDuration={300}
      className="case-detail-template-section"
      classNames={{ chevron: "chevron" }}
      chevron={<IconChevronDown color="white" width={20} height={20} />}
    >
      <Accordion.Item key={title} value={title}>
        <Flex
          bg={"rgb(0, 53, 84)"}
          flex={1}
          align={"center"}
          justify={"space-between"}
          w={"100%"}
          h={44}
          className="header-section"
        >
          <Accordion.Control
            px={0}
            chevron={null}
            className="header-section-action-control"
          >
            <Flex
              flex={1}
              h={44}
              align={"center"}
              style={{ cursor: "pointer" }}
            >
              <Text c={"white"} fw={600} fz={16}>
                {title}
              </Text>
            </Flex>
          </Accordion.Control>
          <Flex>
            <Tooltip label="Edit section" withArrow>
              <ActionIcon bg={"transparent"} onClick={onEditSection}>
                <FaPencilAlt size={14} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Move section" withArrow>
              <ActionIcon
                className="btn-reorder"
                bg={"transparent"}
                {...provided.dragHandleProps}
              >
                <IconMenu2 size={18} />
              </ActionIcon>
            </Tooltip>
            <Accordion.Control px={5}></Accordion.Control>
          </Flex>
        </Flex>
        <Accordion.Panel className="case-detail-template-section_content">
          {children}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default DetailTemplateSection;
